import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {Spin} from "antd"
import Avatar from "../../../../../../statics/assets/images/girl3.png"
import {formatDate} from "../../../../../../helpers/formatDate"
import {getProcessByCustId} from "../../../../../../services/api/apiCustomers"
import parseToken from "../../../../../../helpers/parseToken"

ListActivity.propTypes = {
    custId: PropTypes.number
}

function ListActivity(props) {
    const decodeToken = parseToken()
    const {custId} = props
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [listProcess, setListProcess] = useState([])

    const _fetchProcessLead = async () => {
        setLoading(true)
        setError('')

        try {
            const payload = {
                custId
            }

            const response = await getProcessByCustId(payload, decodeToken.sub)

            const {success, data, error_message} = response

            if (parseInt(success) !== 1) {
                setLoading(false)
                return setError(error_message)
            }

            setLoading(false)
            setError('')
            setListProcess(data)
        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    useEffect(() => {
        _fetchProcessLead()
        // eslint-disable-next-line
    }, [])

    return (
        <div className="Activity">
            <div className="ListProcess">
                <Spin spinning={loading} tip="Đang lấy thông tin...">
                    <ul>
                        {
                            !!listProcess && listProcess.length > 0 && listProcess.map((item, index) => (
                                <li key={index}>
                                    <div className="LeftAvatar">
                                        <div className="Avatar">
                                            <img src={Avatar} alt="avatar"/>
                                        </div>
                                        <div className="User">
                                            <div className="Name">{item.username}</div>
                                            <div className="Content">{item.actionText}</div>
                                        </div>
                                    </div>

                                    <div className="Date">
                                        {formatDate(item.datetime)}
                                    </div>
                                </li>
                            ))
                        }

                        {
                            !!error && error.length > 0 && <div className="Error">{error}</div>
                        }
                    </ul>
                </Spin>
            </div>
        </div>
    )
}

export default ListActivity